import { useState } from "react";
import { Navbar, Nav, Button, Image } from "react-bootstrap";
import { PersonCircle } from "react-bootstrap-icons";
import logo from "../assets/images/ProbeLogoPNG.png";
import { useUser } from "../contexts/user";
import PropTypes from "prop-types";

const Header = ({
    setShowLoginModal
}) => {
    const [isVisible] = useState(true);
    const {isLoggedIn, logout, username} = useUser();

    const logInOutClicked = async () => {
        if (isLoggedIn) {
            await logout();
        }
        else{
            setShowLoginModal(true);
        }
    };

    return (
        <>
            { isVisible && (
                <Navbar
                    expand="md"
                    style={{ backgroundColor: "#181b1f" }}
                    className="px-3"
                >
                    {/* Logo — visible on all sizes */}
                    <Navbar.Brand href="/">
                        <Image src={logo} alt="Probe Logo" style={{ maxHeight: "36px" }} />
                    </Navbar.Brand>

                    <Navbar.Toggle aria-controls="main-navbar-nav" />

                    <Navbar.Collapse id="main-navbar-nav">
                        {/* Divider line only on mobile */}
                        <hr className="d-md-none" style={{ borderColor: "#2e3238", margin: "8px 0" }} />

                        <Nav className="me-auto">
                            <Nav.Link href="/sew" style={{ padding: "10px 12px" }}>
                                SEW Systems
                            </Nav.Link>
                        </Nav>

                        {/* Divider line only on mobile */}
                        <hr className="d-md-none" style={{ borderColor: "#2e3238", margin: "4px 0" }} />

                        <Nav className="align-items-md-center">
                            {username && (
                                <Nav.Item
                                    className="text-light d-flex align-items-center"
                                    style={{ padding: "8px 12px", opacity: 0.75, fontSize: "0.9rem" }}
                                >
                                    <PersonCircle className="me-2" style={{ opacity: 0.6 }} />
                                    {username}
                                </Nav.Item>
                            )}
                            <Nav.Item style={{ padding: "8px 12px 12px" }} className="pb-md-0 pt-md-0 px-md-2">
                                <Button
                                    variant={isLoggedIn ? "outline-light" : "light"}
                                    size="sm"
                                    onClick={logInOutClicked}
                                    className="w-100 w-md-auto"
                                >
                                    <PersonCircle className="me-1" />
                                    {isLoggedIn ? "Log out" : "Log In"}
                                </Button>
                            </Nav.Item>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            )}
        </>
    );
};

Header.propTypes = {
    setShowLoginModal: PropTypes.func.isRequired
};

export default Header;
